/* Lista de modele vine din `espressor-models.json`, nu din pagină: sunt 48 KB
   de care ai nevoie abia când scrii în căutare, iar așa stau în cache-ul
   browserului de la o vizită la alta. Cererea pleacă imediat, nu la primul
   clic — dacă omul scrie înainte să ajungă, căutarea îl așteaptă și atât. */
let SER=[], MD=[], BR=[];
const DATE = fetch(document.getElementById('ck-home').dataset.modele)
  .then(r=>r.json())
  .then(d=>{ SER=d.SER; MD=d.MD; BR=d.BR; gata(); return d; })
  .catch(()=>{ const e=document.getElementById('q');
    if(e){ e.disabled=false; e.placeholder='Scrie modelul, de ex. EP3243'; } });

/* ========== DATE REALE DIN MAGAZIN (21.09.2026) ========== */
const IMG='https://cdn.shopify.com/s/files/1/0806/3067/7853/files/';
const im=(f,w)=>IMG+f+(f.indexOf('?')>0?'&':'?')+'width='+(w||400);

const P={
 cf109:{vid:62712430428509,h:'filtru-apa-compatibil-philips-saeco',t:'Filtru de apă CF109 compatibil AquaClean',s:'Philips · Saeco · 625 cești',p:66,i:im('filtr_CF109.jpg'),
        ppu:'0,11 lei / ceașcă',ppm:'22 lei / lună',life:90},
 cf109x2:{vid:65801729179997,h:'set-2x-filtru-apa-l-philips-saeco-compatibi-cf109-625-cești-x2',t:'Set 2 filtre CF109 compatibile',s:'625 cești fiecare · 6 luni',p:102,i:im('Pumper-Bundles-cmf009-2pack_1800x1800_ba2bec35-30da-4e46-aa29-81f100e59b79.webp'),
        ppu:'0,08 lei / ceașcă',ppm:'17 lei / lună',life:180},
 ca6903:{vid:63875324215645,h:'filtru-de-apa-philips-saeco-aquaclean-ca6903-10',t:'Filtru AquaClean CA6903 original',s:'Philips · Saeco · 625 cești',p:95,c:106,i:im('conca690310_22_c4517a73_jpg.avif'),ppu:'0,15 lei / ceașcă',life:90},
 ca6903x2:{vid:63588080681309,h:'set-2-bucati-filtru-de-apa-philips-saeco-aquaclean-ca6903',t:'Set 2x AquaClean CA6903 original',s:'1.250 de cești',p:149,i:im('res_1f2d8586e867744123e92679e6f77347.avif'),ppu:'0,12 lei / ceașcă',life:180},
 cf101:{vid:66105467273565,h:'filtru-apa-coffix-cf101-pentru-espressoare-jura-compatibil-claris-blue-capacitate-60-l-sau-aproximativ-500-cafele-protectie-anticalcar-utilizare-pana-la-2-luni',t:'Filtru de apă CF101 pentru Jura',s:'compatibil Claris Blue · 60 L / ~500 cafele',p:59.99,i:im('16_93c4f404-91bf-41ff-899a-b2daf88529b8.png'),ppu:'0,12 lei / cafea',life:60},
 cf106:{vid:53031403749725,h:'delonghi-filtru-de-apa',t:'Filtru de apă CF106 compatibil De’Longhi',s:'ECAM, ESAM, ETAM, BCO, EC · 50 L',p:61,i:im('41503464_1-removebg-preview.png'),ppu:'1,22 lei / litru filtrat',ppm:'30 lei / lună',life:60},
 cf106x2:{vid:65801715810653,h:'set-2x-filtru-apa-compatibil-delonghi-cf106-50l-2-luni-1',t:'Set 2 filtre CF106 compatibile',s:'50 L fiecare · 4 luni',p:96,i:im('Pumper-Bundles-shopping_6.webp'),ppu:'0,96 lei / litru filtrat',ppm:'24 lei / lună',life:120},
 tablete:{vid:49881213075805,h:'pastile-curațare-uleiuri-de-cafea-8-buc',t:'Tablete curățare uleiuri Coffeein Clean',s:'8 x 2 g · 8 curățări',p:46,i:im('res_434e81616966f26c297895bab7bf7cb4.jpg'),ppu:'5,75 lei / curățare',life:42},
 pastile:{vid:52249164939613,h:'pastile-2-5gr-curațare-uleiuri-de-cafea-8-buc-copy',t:'Pastile curățare uleiuri de cafea',s:'8 x 2,5 g · 8 curățări',p:47,i:im('download_1.png'),ppu:'5,88 lei / curățare',life:42},
 praf40:{vid:52249390645597,h:'solutie-praf-eliminare-uleiuri-de-cafea-40',t:'Praf curățare uleiuri de cafea 40 g',s:'dozaj flexibil · ~3 curățări profunde',p:44,i:im('Detergent40g.jpg'),ppu:'~14,70 lei / curățare profundă',life:42},
 praf900:{vid:50295332110685,h:'solutie-eliminare-uleiuri-de-cafea',t:'Detergent praf uleiuri Coffeein Clean 900 g',s:'universal · ~60 de curățări la 15 g',p:98,i:im('19_4354aa43-2598-4fb5-bf1d-e06d2e2c3c18.jpg'),ppu:'1,63 lei / curățare',life:180},
 spray:{vid:49881214976349,h:'spray-curațare-uleiuri-de-cafea',t:'Spray degresant portafiltru și grup',s:'CafeaKit · formulă spumantă',p:85,i:im('Detergent_400ml.jpg'),life:90},
 lapte1l:{vid:49881358467421,h:'soluție-curațare-circuit-lapte-1l',t:'Soluție curățare circuit lapte 1 L',s:'universal · ~20 de curățări',p:95,i:im('Milk250ml_c4961e6c-b9c0-4009-9eb7-23ee9ae90766.jpg'),ppu:'4,75 lei / curățare',life:180},
 decPh:{vid:62436490674525,h:'products-solutie-decalcifiere-philips-ca6700-10-250ml-original',t:'Decalcifiant Philips CA6700 250 ml',s:'original · 1 ciclu complet',p:66,i:im('enter-solutie-pentru-masini-de-cafea-philips-ca6700-10-18-preview-webp.webp'),ppu:'66 lei / decalcifiere',life:90},
 decUni500:{vid:49881184108893,h:'solutie-detartrare-500-ml',t:'Soluție decalcifiere universală 500 ml',s:'4 cicluri · De’Longhi, Philips, Krups, Saeco, Jura',p:62,i:im('Decalcinate_500ml_4.jpg'),ppu:'15,50 lei / decalcifiere',life:180},
 decUni250:{vid:49881172214109,h:'solutie-detartrare-250-ml',t:'Soluție decalcifiere universală 250 ml',s:'2 cicluri · universal',p:51,i:im('Decalcunate250ml_6223bfa2-e602-4116-a62c-4c005a5bc5f0.jpg'),ppu:'25,50 lei / decalcifiere',life:90},
 decDel:{vid:62441911779677,h:'soluție-curațare-calcar-delonghi-2-cicluri-original',t:'Decalcifiant De’Longhi original',s:'2 cicluri gata dozate',p:67,i:im('solutie-decalcifiere-delonghi-dlsc200-2x100ml-238050.jpg'),ppu:'33,50 lei / decalcifiere',life:90},
 perie:{st:0,vid:55056733241693,h:'perie-aparate-de-cafea',t:'Perie aparate de cafea',s:'20 cm · duze și grup',p:34,i:im('f63c7370cc2e7a99838b15e4ca16276a.webp'),life:365},
 vaselina:{vid:49815960846685,h:'vaselina-siliconica-alimentara-1buc',t:'Vaselină siliconică alimentară',s:'garnituri și infuzor',p:39,i:im('IMG-8779.jpg'),life:120},
 garnituri:{vid:50357814526301,h:'kit-garnituri-philips-saeco-gaggia',t:'Kit garnituri Philips Saeco Gaggia',s:'infuzor + valvă',p:44,i:im('kit-service-pentru-grup-infuzor-saeco-philips-gaggia-spidem_2226.jpg'),life:365},
 /* seturi */
 kitPh:{vid:63170991489373,h:'kit-anual-pentru-intreținere-espressor-philips-saeco-gaggia',t:'Kit anual Philips, Saeco, Gaggia',s:'2 filtre AquaClean + decalcifiant + 8 tablete',p:169,c:174,i:im('IMG-4030.png'),
        kit:1,g:['filtru','dec','oil'],luni:12,ech:['ca6903x2','decUni250','pastile'],cont:[['2 filtre AquaClean originale','1.250 de cești'],['Decalcifiant 250 ml','2 cicluri'],['8 tablete uleiuri','8 curățări']]},
 kitPhL:{vid:63202792800605,h:'kit-anual-pentru-intreținere-espressor-philips-saeco-gaggia-soluție-pentru-curațarea-circuitului-de-lapte-2-filtre-apa-philips-decalcifiant-250-ml-8-pastile-curațare-uleiuri-de-cafea-soluție-pentru-curațarea-circuitului-de-lapte-250-ml',t:'Kit anual cu circuit de lapte — Philips, Saeco, Gaggia',s:'2 filtre + decalcifiant + 8 tablete + soluție lapte',p:190,c:205,i:im('Gemini_Generated_Image_e4j1dge4j1dge4j1-copie.png'),
        kit:1,g:['filtru','dec','oil','milk'],luni:12,best:1,ech:['ca6903x2','decUni250','pastile'],cont:[['2 filtre AquaClean originale','1.250 de cești'],['Decalcifiant 250 ml','2 cicluri'],['8 tablete uleiuri','8 curățări'],['Soluție circuit lapte 250 ml','5 curățări']]},
 kitPhA:{vid:65453960462685,h:'set-intretinere-anuala-philips-saeco-2-filtre-decalcifiant-lapte-pastile',t:'Set întreținere anuală Philips &amp; Saeco',s:'2 filtre + decalcifiant + circuit lapte + pastile',p:199.2,c:249,i:im('IMG_4439.png'),
        kit:1,luni:12,ech:['ca6903x2','decPh','pastile'],cont:[['2 filtre AquaClean CA6903 originale','1.250 de cești'],['Decalcifiant CA6700','1 ciclu'],['Soluție circuit lapte','5 curățări'],['8 pastile Coffeein Clean','8 curățări']]},
 kitDel:{vid:65261789413725,h:'set-intretinere-delonghi-premium-filtru-cf106-decalcifiere-praf-uleiuri',t:'Set întreținere De’Longhi Premium 3-în-1',s:'filtru CF106 + decalcifiant original + praf uleiuri',p:118.4,c:148,i:im('56206758-55F1-4DE3-8168-6947DF177A9A.png'),
        kit:1,g:['filtru','dec','oil'],luni:6,ech:['cf106','decDel','praf40'],cont:[['Filtru CF106','50 L / 2 luni'],['Decalcifiant De’Longhi','2 decalcifieri'],['Praf curățare uleiuri','curățări repetate']]},
 kitUni:{vid:49881464340829,h:'set-soluții-de-curațare',t:'Set complet universal cu circuit de lapte',s:'decalcifiere + uleiuri + lapte',p:86,i:im('Gemini_Generated_Image_c7hc1dc7hc1dc7hc.png'),
        kit:1,g:['dec','oil','milk'],luni:6,ech:['decUni250','tablete'],cont:[['Soluție decalcifiere','cicluri multiple'],['Curățare uleiuri de cafea','8 curățări'],['Soluție circuit lapte','5 curățări']]},
 kitGrup:{vid:65644779864413,h:'set-reconditionare-si-curatare-grup-infuzor-aparate-cafea-8-x-2g-pastile-curatare-uleiuri-cafea-set-garnituri-si-sita-coffeein-clean®-compatibil-philips-saeco-gaggia-delonghi-jura-krups-bosch-pentru-etansar-presiune-si-extractie-uniforma',t:'Set recondiționare și curățare grup infuzor',s:'8 pastile + garnituri + sită',p:112,i:im('86.png'),kit:1,g:['oil'],luni:12,
        cont:[['8 pastile 2 g','8 curățări'],['Set garnituri + sită','1 recondiționare']]}
};

/* ---- modelele reale din hub-ul de ghiduri ---- */
const BRN={philips:'Philips',saeco:'Saeco',delonghi:"De'Longhi",krups:'Krups',gaggia:'Gaggia',jura:'Jura'};
const TP=['auto','caps','man','drip','semi'];
const TPN={auto:'Espressor automat cu boabe',caps:'Aparat cu capsule',man:'Espressor manual, cu portafiltru',drip:'Cafetieră cu filtru',semi:'Semi-automat'};
const KS=['','frother','lattego','lg_frother'];

/* ---- ce recomandăm, pe marcă ---- */
const REC={
 philips:{dec:'decPh',decAlt:'decUni500',oil:'tablete',filt:'cf109',filt2:'cf109x2',milk:'lapte1l',set:'kitPhL',set2:'kitPh'},
 saeco:{dec:'decPh',decAlt:'decUni500',oil:'tablete',filt:'cf109',filt2:'cf109x2',milk:'lapte1l',set:'kitPhL',set2:'kitPh'},
 gaggia:{dec:'decUni500',oil:'tablete',filt:'cf109',filt2:'cf109x2',milk:'lapte1l',set:'kitPhL',set2:'kitPh'},
 delonghi:{dec:'decDel',decAlt:'decUni500',oil:'praf40',filt:'cf106',filt2:'cf106x2',milk:'lapte1l',set:'kitDel'},
 krups:{dec:'decUni500',decAlt:'decUni250',oil:'tablete',filt:null,milk:'lapte1l',set:'kitUni'},
 jura:{dec:'decUni500',oil:'tablete',filt:'cf101',milk:'lapte1l',set:'kitUni'}
};

const PRAG=199, LIVR_BOX=19, LIVR_CASA=21;

/* ========== utilitare ========== */
const lei=n=>{n=Math.round(n*100)/100;return ((n%1===0)?String(n):n.toFixed(2).replace('.',','))+' lei';};
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const LUNI=['ianuarie','februarie','martie','aprilie','mai','iunie','iulie','august','septembrie','octombrie','noiembrie','decembrie'];

const norm=s=>s.toLowerCase().replace(/[^a-z0-9]/g,'');
function toast(m){const t=$('#toast');t.textContent=m;t.classList.add('on');clearTimeout(t._t);t._t=setTimeout(()=>t.classList.remove('on'),2600);}
function ecSum(k){return (P[k].ech||[]).reduce((s,x)=>s+P[x].p,0);}
const OK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M4 12l5 5L20 6"/></svg>';

/* ========== căutare model ========== */
function caut(q,lim){
  const n=norm(q); if(n.length<1) return [];
  const out=[];
  for(let i=0;i<MD.length;i++){
    const r=MD[i], nm=norm(r[0]), br=BR[r[1]], sr=SER[r[2]];
    let sc=-1;
    if(nm===n) sc=0;
    else if(nm.indexOf(n)===0) sc=1;
    else if(nm.indexOf(n)>0) sc=2;
    else if(norm(br).indexOf(n)===0) sc=3;
    else if(norm(sr).indexOf(n)>=0&&n.length>2) sc=4;
    else if((norm(br)+nm).indexOf(n)>=0) sc=2;
    if(sc>=0) out.push([sc,i]);
  }
  out.sort((a,b)=>a[0]-b[0]||MD[a[1]][0].length-MD[b[1]][0].length);
  return out.slice(0,lim||8).map(x=>MD[x[1]]);
}
function rowObj(r){return {mod:r[0],b:BR[r[1]],ser:SER[r[2]],tip:TP[r[3]],milk:KS[r[4]],url:r[5]?'/pages/curatare-'+r[5]:''};}

function suggHTML(list,fn){
  /* Cand nu gasim modelul, aratam TOATE marcile — nu una singura scrisa in
     cod — plus o cale mai departe pentru cine chiar n-are aparatul la noi. */
  if(!list.length) return '<b>Niciun model găsit</b>'+
    BR.map(b=>'<button onclick="brandPick(\''+b+'\')"><span><span class="sm">'+BRN[b]+'</span><span class="ss">vezi seriile</span></span></button>').join('')+
    '<a class="s-ctc" href="/pages/contact">Nu-ți găsești modelul? Scrie-ne codul de pe etichetă →</a>';
  return '<b>'+list.length+(list.length===1?' rezultat':' rezultate')+'</b>'+list.map((r,i)=>{
    const o=rowObj(r);
    return '<button onclick="'+fn+'(\''+o.b+'\',\''+o.mod.replace(/'/g,"\\'")+'\')"><span><span class="sm">'+BRN[o.b]+' '+o.mod+'</span><span class="ss">'+(o.ser||TPN[o.tip])+'</span></span>'+(o.url?'<span class="sb">are ghid</span>':'')+'</button>';
  }).join('');
}
function findModel(b,m){for(const r of MD){if(BR[r[1]]===b&&r[0]===m) return rowObj(r);}return null;}

/* --- input hero --- */
let SUGI=-1;
function suggMark(){
  const bs=$('#sugg').querySelectorAll('button');
  bs.forEach((b,i)=>b.classList.toggle('sel',i===SUGI));
  if(SUGI>=0&&bs[SUGI]) bs[SUGI].scrollIntoView({block:'nearest'});
}
$('#q').addEventListener('input',e=>{
  const v=e.target.value.trim(), s=$('#sugg'); SUGI=-1;
  if(v.length<1){s.classList.add('hide');return;}
  /* lista de modele vine dintr-un fisier; daca omul scrie mai repede decat
     ajunge ea, ii spunem ca se incarca, nu ca n-avem aparatul lui */
  if(!MD.length){ s.innerHTML='<b>Se \u00eencarc\u0103 lista de modele\u2026</b>'; s.classList.remove('hide'); return; }
  s.innerHTML=suggHTML(caut(v,8),'alege'); s.classList.remove('hide');
});
/* săgeți + Enter: pe desktop se alege fără să pui mâna pe mouse */
$('#q').addEventListener('keydown',e=>{
  const s=$('#sugg'), bs=s.classList.contains('hide')?[]:s.querySelectorAll('button');
  if(e.key==='ArrowDown'&&bs.length){e.preventDefault();SUGI=(SUGI+1)%bs.length;suggMark();}
  else if(e.key==='ArrowUp'&&bs.length){e.preventDefault();SUGI=(SUGI<=0?bs.length:SUGI)-1;suggMark();}
  else if(e.key==='Escape'){s.classList.add('hide');SUGI=-1;}
  else if(e.key==='Enter'){e.preventDefault(); if(SUGI>=0&&bs[SUGI]) bs[SUGI].click(); else pickFirst();}
});
/* butoanele de marcă stau ÎN AFARA cutiei de căutare, deci trebuie scoase din
   regula „clic în altă parte = închide lista" — altfel lista se construia și
   se ascundea în aceeași clipă, iar marca nu făcea nimic. */
document.addEventListener('click',e=>{
  /* pe pagina de acasa nu exista #fitSugg (e al colectiei): fara paza, fiecare clic
     arunca o eroare in consola. */
  if(!e.target.closest('.finder')&&!e.target.closest('.f-help')){const s=$('#sugg'); if(s) s.classList.add('hide');}
  if(!e.target.closest('.fitbox')){const f=$('#fitSugg'); if(f) f.classList.add('hide');}
});
function pickFirst(){const l=caut($('#q').value.trim(),1);if(l.length){const o=rowObj(l[0]);alege(o.b,o.mod);}else toast('Scrie modelul aparatului, e pe eticheta de sub el.');}

/* Marca → seriile ei → modelele seriei. Cine apasă pe o marcă e tocmai omul care
   NU știe codul, iar opt modele din trei sute nu-l ajută cu nimic. */
function brandPick(b){
  heroMarca(b);   /* 3.2 */
  const s=$('#sugg'), bi=BR.indexOf(b), cnt={};
  for(const r of MD){ if(r[1]!==bi) continue; cnt[r[2]]=(cnt[r[2]]||0)+1; }
  const sac=n=>/^(alte|diverse|altele)/i.test(String(n))?1:0;
  const idx=Object.keys(cnt).map(Number).sort((x,y)=>
    sac(SER[x])-sac(SER[y]) || String(SER[x]).localeCompare(String(SER[y]),'ro',{numeric:true}));
  $('#q').value=''; SUGI=-1;
  s.innerHTML='<b>'+BRN[b]+' — alege seria aparatului</b>'+idx.map(i=>
    '<button onclick="serPick('+bi+','+i+')"><span><span class="sm">'+SER[i]+'</span>'+
    '<span class="ss">'+cnt[i]+(cnt[i]===1?' model':' modele')+'</span></span></button>').join('');
  s.classList.remove('hide'); s.scrollTop=0;
}
function serPick(bi,si){
  const s=$('#sugg'), list=MD.filter(r=>r[1]===bi&&r[2]===si);
  s.innerHTML='<b>'+BRN[BR[bi]]+' · '+SER[si]+'</b>'+
    '<button class="back" onclick="brandPick(\''+BR[bi]+'\')"><span><span class="ss back">← înapoi la serii</span></span></button>'+
    list.map(r=>{const o=rowObj(r);
      return '<button onclick="alege(\''+o.b+'\',\''+o.mod.replace(/'/g,"\\'")+'\')"><span>'+
        '<span class="sm">'+BRN[o.b]+' '+o.mod+'</span><span class="ss">'+TPN[o.tip]+'</span></span>'+
        (o.url?'<span class="sb">are ghid</span>':'')+'</button>';}).join('');
  s.classList.remove('hide'); s.scrollTop=0; SUGI=-1;
}

/* ========== rezultatul: ce-i trebuie aparatului ========== */
let CUR=null, CURMILK=true;

function alege(b,m){
  const o=findModel(b,m); if(!o) return;
  CUR=o;
  CURMILK = o.milk? true : (o.tip==='auto');
  $('#sugg').classList.add('hide');
  $('#q').value=BRN[b]+' '+m;
  render();
  $('#rez').hidden=false;
  setTimeout(()=>$('#rez').scrollIntoView({behavior:'smooth',block:'start'}),40);
}
function toggleMilk(v){CURMILK=v;render();}

function taskList(){
  const o=CUR, R=REC[o.b], t=[];
  const areFiltruInMagazin = o.tip==='auto' && R.filt && R.filt!=='soon';
  const areFiltru = o.tip==='auto' && R.filt;

  if(areFiltru){
      const pk=R.filt2||R.filt;
      t.push({g:'filtru',dn:'filtrul de apă',n:'Filtru de apă',f:(o.b==='delonghi'?'la 2 luni / 50 L':o.b==='jura'?'la 2 luni / 60 L':'la 3 luni / 625 cești'),
        w:'Reține o parte din calcarul din apă. Poate modifica intervalul de decalcifiere, dar nu o înlocuiește.',p:pk});
  }
  t.push({g:'dec',dn:'decalcifierea',n:'Decalcifiere',f:'când o cere aparatul'+(areFiltruInMagazin?'; filtrul poate modifica intervalul':', la 2–3 luni'),
    w:'Calcarul se depune în boiler și în circuit. Aparatul pierde presiune, temperatură și gust. '+(areFiltruInMagazin?'Cu filtru montat intervalul poate fi mai lung, dar decalcifierea rămâne.':''),p:R.dec,alt:R.decAlt});

  if(o.tip==='man'||o.tip==='semi'){
    t.push({g:'oil',dn:'curățarea uleiurilor',n:'Uleiuri de cafea, în portafiltru',f:'lunar',w:'Uleiurile se depun în coșul portafiltrului și în duza grupului, și dau gust rânced. Se curăță cu praf sau pastilă puse chiar în coș.',p:'praf40',alt:'spray'});
  } else if(o.tip==='caps'){
    t.push({n:'Compartimentul de capsule',f:'lunar',w:'La aparatele cu capsule se curăță compartimentul și duza, nu grupul de infuzare — aparatul n-are așa ceva.',info:1});
  } else if(o.tip!=='drip'){
    t.push({g:'oil',dn:'curățarea uleiurilor',n:'Uleiuri de cafea',f:'la 4–6 săptămâni',w:'Cafeaua lasă un strat gras în grupul de infuzare. Se simte în ceașcă înainte să se vadă.',p:R.oil});
  }

  if(CURMILK && (o.tip==='auto'||o.tip==='semi')){
    t.push({g:'milk',dn:'circuitul de lapte',n:'Circuitul de lapte',f:'la 3–5 săptămâni',w:'Laptele lasă depuneri de proteine și grăsimi în tuburi. Nu e opțional: clătirea cu apă nu le scoate.',p:R.milk});
  }
  return t;
}
function nuTrebuie(){
  const o=CUR,x=[];
  if(o.tip==='caps'||o.tip==='drip'||o.tip==='man'||o.tip==='semi'){
    x.push('filtru de apă montat în aparat — modelul tău n-are locaș de filtru');
    x.push('tablete de degresare puse în grupul de infuzare — aparatul n-are grup demontabil');
    x.push('garnituri, sită sau vaselină de infuzor');
  }
  if(o.b==='delonghi') x.push('pastile de degresare — la De’Longhi se folosește praf, pus în pâlnia de cafea măcinată');
  if(o.b==='krups') x.push('praf de degresare — la Krups se folosesc pastilele');
  if(!CURMILK&&(o.tip==='auto')) x.push('soluție pentru circuitul de lapte — ai spus că nu faci băuturi cu lapte');
  return x;
}

/* Setul se alege dupa APARAT, nu dupa marca — regula 27. Setul marcii ramane
   daca se potriveste; filtrul de apa e singurul lucru care descalifica un set,
   fiindca aparatul fara locas nu-l poate folosi deloc. Sub doua lucruri
   acoperite nu mai e un set, e un produs mai scump. */
function alegeSet(T){
  const nevoi=T.filter(t=>t.p).map(t=>t.g), areFiltru=nevoi.indexOf('filtru')>=0, R=REC[CUR.b];
  /* Candidatii sunt NUMAI seturile marcii plus cel universal. Regula 9: kitul
     anual are filtre AquaClean, deci nu are ce cauta la Jura, Krups sau
     De'Longhi — o cautare prin tot catalogul l-ar fi oferit acolo. */
  let best=null;
  for(const k of [R.set,R.set2,'kitUni']){ const s=P[k]; if(!s||!s.g) continue;
    if(!areFiltru&&s.g.indexOf('filtru')>=0) continue;          /* regula 27 */
    const n=nevoi.filter(g=>s.g.indexOf(g)>=0).length;
    if(n<2) continue;
    const plus=s.g.filter(g=>nevoi.indexOf(g)<0).length;         /* ce nu-i trebuie */
    /* la egalitate castiga setul MARCII, fiindca e ales pentru aparatele ei:
       decalcifiantul original, filtrul potrivit. Candidatii sunt in ordinea
       R.set, R.set2, kitUni, iar aici se cere strict mai bun ca sa schimbe. */
    if(!best||n>best.n||(n===best.n&&plus<best.plus)) best={k:k,n:n,plus:plus};
  }
  return best?best.k:null;
}

function render(){
  const o=CUR, R=REC[o.b], T=taskList(), NU=nuTrebuie();
  const keys=T.filter(t=>t.p).map(t=>t.p);
  const total=keys.reduce((s,k)=>s+P[k].p,0);
  const setK=alegeSet(T), S=setK?P[setK]:null;

  let h='<div class="rez-head"><div>'+
    '<p class="eyebrow" style="margin:0">Am găsit modelul tău</p>'+
    '<h2>'+BRN[o.b]+' '+o.mod+'</h2>'+
    '<p class="small muted" style="margin:2px 0 0">'+TPN[o.tip]+(o.ser?' · '+o.ser:'')+'</p></div>'+
    '<button class="rez-close" onclick="document.getElementById(\'rez\').hidden=true" aria-label="Închide">✕</button></div>';

  if(o.tip==='auto'||o.tip==='semi'){
    h+='<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-bottom:14px">'+
      '<span class="small muted">Faci băuturi cu lapte?</span>'+
      '<button class="pill'+(CURMILK?' pill-blue':'')+'" onclick="toggleMilk(true)">Da</button>'+
      '<button class="pill'+(!CURMILK?' pill-blue':'')+'" onclick="toggleMilk(false)">Nu</button></div>';
  }

  /* acțiunea stă SUS: pe telefon, butonul de coș era la 1.368 px de începutul
     cardului, adică trei ecrane de derulat prin explicații. */
  if(keys.length){
    const jk=JSON.stringify(keys).replace(/"/g,'&quot;');
    const minPret = S ? Math.min(total,S.p) : total;
    h+='<div class="actbar">'+
      '<div class="actsum"><span>Tot ce-i trebuie, la bucată — '+keys.length+' produse</span><b>'+lei(total)+'</b></div>'+
      '<button class="btn btn-pri" onclick="addAll('+jk+')">Adaugă toate cele '+keys.length+' în coș</button>'+
      (S?'<button class="btn" onclick="add(\''+setK+'\')">Sau setul — '+lei(S.p)+'</button>':'')+
      '<div class="xs">'+pragText(total)+' · card sau ramburs · retur gratuit 14 zile</div>'+
      /* 3.7: data vine din livrare(), care respecta politica de expediere a
         magazinului. E estimare, si asa scrie — nu promitem o zi anume. */
      '<div class="xs liv">Comanzi acum → livrare <b>'+livrare().s+'</b> <span class="muted">('+livrare().l+')</span></div>'+
      '</div>';
  }
  h+='<p style="margin:0 0 12px"><b class="af">Are nevoie de '+T.length+' lucruri.</b> <span class="muted small">Frecvențele de mai jos sunt din manualul modelului tău, acolo unde manualul le dă.</span></p>';
  h+='<div class="grid g2">';
  T.forEach((t,i)=>{
    h+='<div class="task'+(t.p?' on':'')+'"><div class="task-n">'+(i+1)+'</div><div style="flex:1">'+
       '<h3>'+t.n+'</h3><div class="freq">'+t.f+'</div><div class="why">'+t.w+'</div>';
    if(t.p){const p=P[t.p];
      const adr=p.h?('/products/'+p.h):'';
      h+='<div class="pline"><img src="'+p.i+'" alt="'+p.t+'" loading="lazy"><div class="pn">'+(adr?('<a href="'+adr+'">'+p.t+'</a>'):p.t)+'<br><span class="muted xs">'+(p.s||'')+'</span></div>'+
         '<div class="pp">'+lei(p.p)+(p.ppu?'<span class="ppu">'+p.ppu+'</span>':'')+'</div></div>';
      if(t.alt&&P[t.alt]) h+='<div class="xs muted" style="margin-top:6px">Alternativă: '+P[t.alt].t+' — '+lei(P[t.alt].p)+(P[t.alt].ppu?' ('+P[t.alt].ppu+')':'')+'</div>';
    }
    if(t.info) h+='<div class="xs muted" style="margin-top:6px">Se face cu o capsulă de curățare — n-o vindem, deci nu-ți recomandăm nimic aici.</div>';
    h+='</div></div>';
  });
  h+='</div>';

  if(NU.length) h+='<div class="nolist" style="margin-top:12px"><b class="af small">Ce NU îi trebuie</b><ul style="margin:6px 0 0;padding-left:18px">'+NU.map(x=>'<li>'+x+'</li>').join('')+'</ul></div>';

  /* sumar + acțiuni */
  h+='<div class="sumbar">';
  if(keys.length){
    h+='<div class="sumrow"><span>Tot ce-i trebuie, la bucată</span><span class="t">'+lei(total)+'</span></div>';
    h+='<button class="btn btn-pri" style="margin-top:10px" onclick="addAll('+JSON.stringify(keys).replace(/"/g,'&quot;')+')">Adaugă toate cele '+keys.length+' în coș</button>';
    if(S){
      /* Ce acoperă setul din lista de mai sus și ce NU acoperă — cu prețurile
         produselor noastre. Fără „economisești" și fără „pe lună": chenarul
         ăsta a avut cândva două economii care se contraziceau, fiindcă una
         compara setul cu o listă în care intrau și produse pe care setul nu
         le conține. Cantitățile din set nu sunt aceleași ca la produsele
         luate separat, deci nu afirmăm o economie — arătăm amândouă prețurile. */
      const gset=S.g||[], acop=T.filter(t=>t.p&&gset.indexOf(t.g)>=0), lipsa=T.filter(t=>t.p&&gset.indexOf(t.g)<0);
      const pAcop=acop.reduce((s,t)=>s+P[t.p].p,0);
      const adrS=S.h?('/products/'+S.h):'';
      h+='<div class="upg" style="margin-top:10px"><div style="display:flex;gap:10px;align-items:center">'+
         '<img src="'+S.i+'" alt="'+S.t+'" style="width:56px;height:56px;object-fit:contain;background:#fff;border-radius:10px" loading="lazy">'+
         '<div style="flex:1"><b class="af small">'+(adrS?('<a href="'+adrS+'">'+S.t+'</a>'):S.t)+'</b><div class="xs muted">'+S.s+'</div></div>'+
         '<div style="text-align:right"><b class="af">'+lei(S.p)+'</b>'+(S.c&&S.c>S.p?'<div class="xs muted"><s>'+lei(S.c)+'</s></div>':'')+'</div></div>'+
         (S.cont?'<ul class="upg-l">'+S.cont.map(c=>'<li>'+c[0]+'<i>'+c[1]+'</i></li>').join('')+'</ul>':'')+
         '<div class="small" style="margin-top:8px">'+
           (acop.length?'Acoperă '+acop.length+' din cele '+(acop.length+lipsa.length)+' lucruri de mai sus'+
              (acop.length>1?' ('+acop.map(t=>t.dn||t.n.toLowerCase()).join(', ')+')':'')+
              ', care luate separat costă <b>'+lei(pAcop)+'</b>.':'')+
           (lipsa.length?' <b>Nu include</b> '+lipsa.map(t=>(t.dn||t.n.toLowerCase())+' ('+lei(P[t.p].p)+')')
              .join(' și ')+', de care aparatul tău are nevoie.':'')+
         '</div>'+
         formAdd(setK,'Ia setul în loc','btn')+'</div>';
    }
  }
  if(o.url) h+='<a class="btn" style="margin-top:10px" href="'+o.url+'" target="_blank" rel="noopener">Citește ghidul de curățare pentru '+o.mod+' →</a>';
  else h+='';
  h+='</div>';

  $('#rezCard').innerHTML=h;
  stkPaint();
}

/* ========== PRIMA PAGINĂ ========== */

/* modelele cele mai căutate — doar cele care chiar există în date */

/* cardul de set din hero, pe desktop */
function paintHeroKit(){
  const k=setMarcii(HEROB), p=P[k];
  document.getElementById('heroKit').innerHTML=
    '<div class="hcard"><span class="hc-tag">Cel mai des luat</span>'+
    '<div class="hc-ph"><img src="'+p.i+'" srcset="'+srcset(p.i)+'" sizes="(min-width:1000px) 300px, 90vw" alt="'+p.t+'" fetchpriority="high"></div>'+
    '<h2>'+p.t+'</h2>'+
    '<div class="hc-p">'+lei(p.p)+'<small>'+p.s+'</small></div>'+
    '<div class="hc-ec">La bucată: de la <s>'+lei(ecSum(k))+'</s> — economisești <b>cel puțin '+lei(ecSum(k)-p.p)+'</b></div>'+
    formAdd(k,'Adaugă în coș','btn btn-pri')+
    '<div class="xs muted" style="text-align:center">Transport 19 lei · retur gratuit 14 zile</div></div>';
}

/* operațiile de întreținere, pe scurt */
const NEVOI_CARD=[
 {u:'/collections/solutii-de-curatare',t:'Decalcifiere', f:'La 2–3 luni, sau când o cere aparatul', g:'decalcifiere', p:'decUni500',
  d:'Calcarul se depune în boiler și în circuit. Aparatul pierde presiune, pierde temperatură, iar cafeaua iese fadă.', ppu:'de la 15,50 lei / decalcifiere'},
 {u:'/collections/solutii-de-curatare',t:'Uleiuri de cafea', f:'La 4–6 săptămâni', g:'uleiuri', p:'praf900',
  d:'Cafeaua lasă un strat gras în grupul de infuzare. Se simte în ceașcă — gust rânced, amar — înainte să se vadă.', ppu:'de la 1,63 lei / curățare'},
 {u:'/collections/solutii-de-curatare',t:'Circuitul de lapte', f:'La 3–5 săptămâni', g:'lapte', p:'lapte1l',
  d:'Laptele lasă proteine și grăsimi în tuburi. Clătirea cu apă nu le scoate, și nu e opțional.', ppu:'4,75 lei / curățare'},
 {u:'/collections/piese',t:'Filtrul de apă', f:'La 3 luni / 625 de cești', g:'filtru', p:'cf109x2',
  d:'Reține o parte din calcarul din apă. Poate modifica intervalul de decalcifiere, dar nu o înlocuiește.', ppu:'de la 0,08 lei / ceașcă'}
];
function paintNevoi(){
  document.getElementById('nevoiGrid').innerHTML=NEVOI_CARD.map(n=>
    '<div class="nev"><div class="nev-ph"><img src="'+P[n.p].i+'" alt="'+P[n.p].t+'" loading="lazy"></div>'+
    '<h3>'+n.t+'</h3><div class="nev-f">'+n.f+'</div>'+
    '<p>'+n.d+'</p><div class="sp"></div>'+
    '<div class="nev-p">'+n.ppu+'</div>'+
    '<a class="btn btn-sm" style="width:100%" href="'+(n.u||'/collections/intretinere')+'">Vezi produsele</a></div>').join('');
}

/* seturile */
function paintSeturi(){
  const k='kitPhL', p=P[k];
  document.getElementById('kitErou').innerHTML=
    '<div class="erou"><div class="erou-ph"><img src="'+p.i+'" alt="'+p.t+'" loading="lazy"></div>'+
    '<div class="erou-b"><span class="hc-tag" style="position:static;display:inline-block;margin-bottom:8px">Cel mai des luat</span>'+
    '<h3>'+(p.h?('<a href="/products/'+p.h+'">'+p.t+'</a>'):p.t)+'</h3>'+
    '<p class="muted small" style="margin:4px 0 10px">Produsele de întreținere pentru un espressor Philips, Saeco sau Gaggia cu sistem de lapte, într-un singur pachet.</p>'+
    '<ul class="erou-l">'+p.cont.map(c=>'<li>'+OK+'<span>'+c[0]+'</span><i>'+c[1]+'</i></li>').join('')+'</ul>'+
    '<div class="erou-pr"><div><span class="big">'+lei(p.p)+'</span><span class="sm2">'+p.s+'</span></div>'+
    '<div class="erou-ec">La bucată: de la <s>'+lei(ecSum(k))+'</s><b>economisești cel puțin '+lei(ecSum(k)-p.p)+'</b></div></div>'+
    formAdd(k,'Adaugă în coș — '+lei(p.p),'btn btn-pri')+
    '<div class="xs muted" style="text-align:center;margin-top:6px">Transport 19 lei · gratuit peste 199 lei · retur gratuit 14 zile</div>'+
    '</div></div>';
  document.getElementById('kitAlte').innerHTML=['kitDel','kitUni'].map(kitCard).join('');
}

/* cât costă pe lună */
let CZI=1, CLAPTE=true;
const ZI_OPT=[[1.5,'1–2 cafele'],[4,'3–5 cafele'],[7,'peste 5 cafele']];
function setZi(i){CZI=i;calcPaint();}
function setLap(v){CLAPTE=v;calcPaint();}
function calcPaint(){
  document.getElementById('calcZi').innerHTML=ZI_OPT.map((o,i)=>
    '<button class="chip'+(CZI===i?' on':'')+'" onclick="setZi('+i+')">'+o[1]+'</button>').join('');
  document.getElementById('calcLapte').innerHTML=
    '<button class="chip'+(CLAPTE?' on':'')+'" onclick="setLap(true)">Da</button>'+
    '<button class="chip'+(!CLAPTE?' on':'')+'" onclick="setLap(false)">Nu</button>';

  const pe_zi=ZI_OPT[CZI][0], cesti=Math.round(pe_zi*365);
  const nFiltre=Math.ceil(cesti/625), cFiltru=nFiltre*51;
  const nUlei=10, cUlei=Math.round(nUlei*5.75);
  const nLapte=CLAPTE?13:0, cLapte=Math.round(nLapte*4.75);
  const nDec=2, cDec=Math.round(nDec*15.5);
  const tot=cFiltru+cUlei+cLapte+cDec, luna=Math.round(tot/12);
  const kit=CLAPTE?'kitPhL':'kitPh';
  document.getElementById('calcOut').innerHTML=
    '<div class="calc-out"><table class="calc-t">'+
    '<tr><td>Filtre de apă</td><td>'+nFiltre+' pe an, la '+cesti.toLocaleString('ro-RO')+' de cești</td><td>'+lei(cFiltru)+'</td></tr>'+
    '<tr><td>Uleiuri de cafea</td><td>'+nUlei+' curățări pe an</td><td>'+lei(cUlei)+'</td></tr>'+
    (CLAPTE?'<tr><td>Circuitul de lapte</td><td>'+nLapte+' curățări pe an</td><td>'+lei(cLapte)+'</td></tr>':'')+
    '<tr><td>Decalcifiere</td><td>'+nDec+' pe an (estimare)</td><td>'+lei(cDec)+'</td></tr>'+
    '<tr class="t"><td colspan="2">Într-un an</td><td>'+lei(tot)+'</td></tr>'+
    '</table>'+
    '<div class="calc-big"><b>≈ '+lei(luna)+' pe lună.</b> Cam cât două cafele la oraș — pentru un aparat care te costă de o sută de ori mai mult.</div>'+
    '<p class="small muted" style="margin:10px 0 0">Calculat cu prețurile de pe site, la pachetele de câte două filtre. „'+P[kit].t+'" acoperă cea mai mare parte din listă, la '+lei(P[kit].p)+'.</p>'+
    '</div>';
}

/* obiecțiile */


/* ========== secțiunile de pe prima pagină ========== */
function kitCard(k){
  const p=P[k];
  return '<div class="kit'+(p.best?' best':'')+'">'+
    (p.best?'<div class="kit-tag b">Cel mai des luat</div>':(p.c?'<div class="kit-tag">Preț redus</div>':'<div class="kit-tag" style="background:#f6f7fb;color:var(--gray)">Set</div>'))+
    '<div class="kit-b"><div class="kit-ph"><img src="'+p.i+'" alt="'+p.t+'" loading="lazy"></div>'+
    '<h3>'+(p.h?('<a href="/products/'+p.h+'">'+p.t+'</a>'):p.t)+'</h3>'+
    '<div class="permo">'+lei(p.p)+'<small>'+p.s+'</small></div>'+
    (p.ech?'<div class="econ">Produsele din el, la bucată: de la <s>'+lei(ecSum(k))+'</s> — <b>economisești cel puțin '+lei(ecSum(k)-p.p)+'</b></div>':'')+
    '<ul>'+p.cont.map(c=>'<li>'+OK.replace('stroke-width="3"','stroke-width="3" style="color:var(--ok)"')+c[0]+'<span>'+c[1]+'</span></li>').join('')+'</ul>'+
    '<div class="sp"></div>'+
    formAdd(k,'Adaugă — '+lei(p.p),'btn'+(p.best?' btn-pri':''))+
    '<div class="xs muted" style="text-align:center">'+(p.p>=PRAG?'Transport gratuit':'+19 lei livrare · gratuit peste 199 lei')+' · retur 14 zile</div>'+
    '</div></div>';
}





/* ========== reminder: în calendarul lui, nu pe lista noastră ==========
   Nu promitem un e-mail pe care n-avem cum să-l trimitem la timp: nu știm ce aparat
   are omul și nici când i se termină ce-a cumpărat. Calendarul lui știe. */
const CAL=[
 {t:'Decalcifiere',       i:'la 3 luni',        r:'FREQ=MONTHLY;INTERVAL=3', z:90,
  d:'Decalcifiază espressorul. Îți trebuie soluție de decalcifiere.'},
 {t:'Uleiuri de cafea',   i:'la 4–6 săptămâni', r:'FREQ=WEEKLY;INTERVAL=5',  z:35,
  d:'Curăță uleiurile de cafea. Îți trebuie pastile sau praf de degresare.'},
 {t:'Circuitul de lapte', i:'la 3–5 săptămâni', r:'FREQ=WEEKLY;INTERVAL=4',  z:28,
  d:'Curăță circuitul de lapte cu soluție. Clătirea cu apă nu scoate grăsimea.'},
 {t:'Filtrul de apă',     i:'la 3 luni',        r:'FREQ=MONTHLY;INTERVAL=3', z:90,
  d:'Schimbă filtrul de apă.'}
];
function paintCal(){
  const c=document.getElementById('cal'); if(!c) return;
  c.innerHTML=CAL.map((o,i)=>
    '<div class="cal-r"><div class="n"><b>'+o.t+'</b><span>'+o.i+'</span></div>'+
    '<button class="btn" onclick="calAdd('+i+')">În calendar</button></div>').join('');
}
function ic2(n){return (n<10?'0':'')+n;}
function icZi(d){return d.getFullYear()+ic2(d.getMonth()+1)+ic2(d.getDate());}
function icTxt(s){return String(s).replace(/([\\;,])/g,'\\$1');}
function icFold(s){var o=[];while(s.length>60){o.push(s.slice(0,60));s=' '+s.slice(60);}o.push(s);return o.join('\r\n');}
/* 3.10 — unde duce reamintirea: la rezultatul modelului, daca stim modelul */
function calLink(){
  const b='https://cafeakit.ro/';
  if(typeof CUR!=='undefined' && CUR && CUR.mod)
    return b+'?model='+encodeURIComponent(CUR.mod)+'&b='+encodeURIComponent(CUR.b);
  return b+'collections/intretinere';
}

/* ...si cum se citeste inapoi, cand omul revine de pe telefon */
function dinAdresa(){
  const u=new URLSearchParams(location.search), m=u.get('model');
  if(!m) return;
  const b=u.get('b');
  if(b && findModel(b,m)) { alege(b,m); return; }
  const r=caut(m,1)[0];
  if(r) alege(BR[r[1]], r[0]);
}

function calAdd(i){
  const o=CAL[i], d=new Date(); d.setDate(d.getDate()+o.z);
  const d2=new Date(d); d2.setDate(d2.getDate()+1);
  const L=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//CafeaKit//intretinere//RO','CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    'UID:ck'+Date.now()+i+'@cafeakit.ro',
    'DTSTAMP:'+new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,''),
    'DTSTART;VALUE=DATE:'+icZi(d),
    'DTEND;VALUE=DATE:'+icZi(d2),
    'RRULE:'+o.r,
    'SUMMARY:'+icTxt((CUR?CUR.mod+' — ':'Espressor — ')+o.t),
    /* 3.10: peste trei luni, omul nu mai cauta modelul a doua oara —
       legatura il duce direct la ce-i trebuie aparatului LUI */
    'DESCRIPTION:'+icTxt(o.d+' Ce-i trebuie aparatului tău: '+calLink()),
    'BEGIN:VALARM','TRIGGER:PT9H','ACTION:DISPLAY','DESCRIPTION:'+icTxt('Espressor — '+o.t),'END:VALARM',
    'END:VEVENT','END:VCALENDAR'].map(icFold).join('\r\n');
  const nume='cafeakit-'+o.t.toLowerCase().replace(/[^a-z]+/g,'-').replace(/^-|-$/g,'')+'.ics';
  try{
    const b=new Blob([L],{type:'text/calendar;charset=utf-8'}), u=URL.createObjectURL(b);
    const a=document.createElement('a'); a.href=u; a.download=nume;
    document.body.appendChild(a); a.click();
    setTimeout(function(){URL.revokeObjectURL(u); a.remove();},2000);
  }catch(e){
    window.location.href='data:text/calendar;charset=utf-8,'+encodeURIComponent(L);
  }
  toast('Gata — deschide fișierul descărcat ca să intre în calendar.');
}

/* ========== grupe și mărci, din titlurile reale din magazin (regula 12) ========== */
const GRUP={
  seturi:['kitPhL','kitPhA','kitPh','kitDel','kitUni','kitGrup'],
  filtru:['cf101','cf109x2','cf109','ca6903x2','ca6903','cf106x2','cf106'],
  decalcifiere:['decUni500','decPh','decDel','decUni250'],
  uleiuri:['tablete','pastile','praf900','praf40','spray'],
  lapte:['lapte1l'],
  piese:['garnituri','vaselina','perie']
};
const NEVOI=[['toate','Tot'],['seturi','Seturi'],['filtru','Filtre de apă'],['decalcifiere','Decalcifiere'],['uleiuri','Uleiuri de cafea'],['lapte','Circuit de lapte'],['piese','Piese']];
const MARCI={
  cf109:['philips','saeco'], cf109x2:['philips','saeco'], ca6903:['philips','saeco'], ca6903x2:['philips','saeco'],
  cf101:['jura'],

  cf106:['delonghi'], cf106x2:['delonghi'],
  tablete:['philips','saeco','delonghi','jura','krups'], pastile:['delonghi','philips','saeco','jura'],
  praf40:['delonghi','philips','saeco'], praf900:['delonghi','philips','saeco'], spray:[],
  lapte1l:['delonghi','philips','saeco','jura','krups'],
  decPh:['philips','saeco'], decUni500:['delonghi','philips','krups','saeco','jura'], decUni250:[],
  decDel:['delonghi'], 
  perie:[], vaselina:[], garnituri:['philips','saeco','gaggia'],
  kitPh:['philips','saeco','gaggia'], kitPhL:['philips','saeco','gaggia'], kitPhA:['philips','saeco'],
    kitDel:['delonghi'], kitUni:[], kitGrup:['philips','saeco','gaggia','delonghi','jura','krups']
};

const FARA_GRUP=['delonghi','jura','krups'];
/* regulile de produs ale lui Andrei, într-un singur loc */


/* ========== termenul de livrare, exact după politica magazinului ========== */
function fmtZi(d){return d.getDate()+' '+LUNI[d.getMonth()];}
function livrare(){
  const d=new Date(), zi=d.getDay(), ora=d.getHours(), dt=new Date(d);
  if(zi>=1&&zi<=4&&ora<15){dt.setDate(d.getDate()+1);return {s:'estimată '+fmtZi(dt)+' (24–72 h)',l:'comandă plasată până la 15:00'};}
  if(zi>=1&&zi<=4){dt.setDate(d.getDate()+2);return {s:'în 48–72 h',l:'ai trecut de ora 15:00'};}
  if(zi===5&&ora<15) return {s:'în 24–72 h',l:'comandă de vineri'};
  const plus = zi===5?4:(zi===6?3:2); dt.setDate(d.getDate()+plus);
  return {s:'estimată marți, '+fmtZi(dt),l:'comenzile de vineri după 15:00 și din weekend se livrează marți'};
}


/* ========== coșul real al magazinului ========== */
function formAdd(k,label,cls){
  return '<form class="add" action="/cart/add" method="post" onsubmit="return ckSubmit(event,[\''+k+'\'])">'+
    '<input type="hidden" name="id" value="'+P[k].vid+'">'+
    '<input type="hidden" name="quantity" value="1">'+
    '<button type="submit" class="'+(cls||'btn')+'">'+label+'</button></form>';
}
function ckSubmit(e,keys){ e.preventDefault(); ckAdd(keys); return false; }
function add(k,q){ ckAdd([k],q); }
function addAll(keys){ ckAdd(keys); }
function ckAdd(keys,q){
  const items=keys.map(k=>({id:P[k].vid,quantity:q||1}));
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/javascript'},
    body:JSON.stringify({items:items,sections:'cart-drawer,cart-icon-bubble'})})
  .then(r=>r.json()).then(d=>{
    if(d.status){ toast(d.description||'Nu s-a putut adăuga în coș.'); return; }
    const dr=document.querySelector('cart-drawer');
    if(d.sections&&dr&&typeof dr.renderContents==='function'){
      dr.renderContents(d);
      if(dr.classList.contains('is-empty')) dr.classList.remove('is-empty');
      toast(keys.length>1?keys.length+' produse adăugate':'Adăugat în coș');
      cosCiteste(); /*dupa adaugare*/
    } else { window.location.href='/cart'; }
  }).catch(()=>{ window.location.href='/cart'; });
}

/* ========== latimea intreaga ==========
   Iesirea din coloana ingusta se face in CSS, deci se recalculeaza singura la orice
   latime. Din JS vine o singura cifra: latimea barei de derulare, pe care 100vw o
   numara dar ecranul n-o are. */
function ckBara(){
  const sb=Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  document.documentElement.style.setProperty('--ck-sb', sb+'px');
}
ckBara();
window.addEventListener('resize',ckBara,{passive:true});
window.addEventListener('load',ckBara);
/* Bara de derulare poate sa apara si fara ca fereastra sa se redimensioneze (creste
   continutul, se inchide bannerul de cookie), deci urmarim direct pagina. Observam BODY,
   nu elementul radacina: ckBara scrie o proprietate pe radacina, iar un observator care se uita chiar
   la elementul pe care il modifica intra in „ResizeObserver loop" si browserul ii taie
   notificarile urmatoare, in tacere. Asa a ramas pagina cu 8 px de derulare laterala. */
if(window.ResizeObserver){ try{ new ResizeObserver(ckBara).observe(document.body||document.documentElement); }catch(e){} }
/* si doua verificari de asezare, dupa ce se aseaza si ce incarca tema */
setTimeout(ckBara,400); setTimeout(ckBara,2000);

/* 2.7 — tema isi pune singura un semn in sessionStorage cand pop-up-ul a fost
   vazut. Il punem noi, deci pe pagina asta nici nu porneste. Stilul de mai sus
   il tine ascuns si daca semnul nu merge (fereastra privata). */
try{ sessionStorage.setItem('ck_popup_seen','1'); }catch(e){}

/* 5.4 — aceeasi poza, in mai multe marimi: telefonul ia 300 px, nu 600 */
function srcset(u){
  if(!u || u.indexOf('cdn.shopify.com')<0) return '';
  const b=u.split('?')[0];
  return b+'?width=200 200w, '+b+'?width=300 300w, '+b+'?width=400 400w, '+b+'?width=600 600w';
}

/* ========== 3.4 + 3.2 ==========
   Pe telefon, cardul de set din erou e ascuns, deci primul ecran n-avea nici
   un pret. Randul asta il inlocuieste, si se schimba odata cu marca aleasa. */
let HEROB = null;   /* marca aleasa din pastile; null = ce recomandam implicit */

/* setul care se arata pentru o marca, cu grija la stoc (2.2) */
function setMarcii(b){
  const r = b && REC[b] ? REC[b] : null;
  return cuStoc(r && r.set ? r.set : 'kitPhL', 'kitUni') || cuStoc('kitUni');
}

/* ce produse intra in randul de sus: setul marcii, apoi cate unul din fiecare
   nevoie. Ce n-are stoc nu intra deloc. */
function prowKeys(){
  const r = HEROB && REC[HEROB] ? REC[HEROB] : null;
  const vrem = [setMarcii(HEROB),
                r ? (r.dec||'decUni500') : 'decUni500',
                r ? (r.oil||'tablete') : 'tablete',
                r ? (r.milk||'lapte1l') : 'lapte1l',
                r ? (r.filt2||r.filt) : 'cf109x2'];
  const out=[];
  for(const k of vrem){ if(k && disp(k) && out.indexOf(k)<0) out.push(k); }
  return out.slice(0,5);
}

function paintProw(){
  const el=document.getElementById('ckProw'); if(!el) return;
  el.innerHTML = prowKeys().map(k=>{ const p=P[k];
    const adr=p.h?('/products/'+p.h):'';
    return '<div class="pr-it">'+
      (adr?'<a href="'+adr+'">':'')+'<img src="'+p.i+'" srcset="'+srcset(p.i)+'" sizes="146px" alt="'+p.t+'" loading="lazy">'+(adr?'</a>':'')+
      '<div class="pr-n">'+(adr?('<a href="'+adr+'">'+p.t+'</a>'):p.t)+'</div>'+
      '<div class="pr-p">'+lei(p.p)+'</div>'+
      '<button class="btn btn-sm" type="button" onclick="add(\''+k+'\')">Adaugă</button></div>';
  }).join('');
}

/* 3.2 — marca schimba produsul vedeta, fara reincarcare */
function heroMarca(b){
  HEROB = b;
  paintHeroKit(); paintProw(); stkPaint();
}
function altaMarca(){
  HEROB=null; paintHeroKit(); paintProw(); stkPaint();
  const s=$('#sugg');
  s.innerHTML='<b>Produse universale</b>'+
    ['decUni500','tablete','lapte1l'].filter(disp).map(k=>
      '<button onclick="add(\''+k+'\')"><span><span class="sm">'+P[k].t+'</span>'+
      '<span class="ss">'+(P[k].s||'')+'</span></span><span class="sb">'+lei(P[k].p)+'</span></button>').join('')+
    '<a class="s-ctc" href="/collections/solutii-de-curatare">Vezi toate soluțiile de curățare →</a>';
  s.classList.remove('hide');
}

/* ========== 2.2 / 3.5 / 3.6 ==========
   Trei lucruri care tin unul de altul: ce se poate cumpara azi, ce scrie in
   bara de jos si cat mai lipseste pana la transport gratuit. */

/* 2.2 — produsul fara stoc nu se recomanda si nu primeste buton. Stocul se
   scrie in catalog de `claude_home_preturi.py`, la fiecare generare. */
function disp(k){ return !!P[k] && P[k].st!==0; }
/* daca ce recomandam nu e pe stoc, cade pe alternativa; daca nici aceea, pe
   nimic — mai bine lipsa decat un buton care nu merge */
function cuStoc(k, alt){
  if(disp(k)) return k;
  if(alt && disp(alt)) return alt;
  for(const x in P){ if(P[x].kit) continue; if(!disp(x)) continue;
    if(P[x].g && P[k] && P[k].g && P[x].g===P[k].g) return x; }
  return null;
}

/* 3.6 — cosul real. Pe proba locala `/cart.js` nu exista, deci se trateaza
   linistit ca un cos gol: pagina nu are voie sa crape din asta. */
let COS = {total:0, gata:false};
function cosCiteste(){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(r=>r.ok?r.json():null)
    .then(d=>{ COS={total: d? d.total_price/100 : 0, gata:true}; stkPaint(); return COS; })
    .catch(()=>{ COS={total:0, gata:true}; stkPaint(); return COS; });
}
function lipsaTransport(inPlus){
  const t = COS.total + (inPlus||0);
  return t >= PRAG ? 0 : Math.round((PRAG - t)*100)/100;
}
/* cel mai ieftin produs care chiar se poate cumpara azi, ca sa treci pragul */
function micPentruPrag(){
  let best=null;
  for(const k in P){ const p=P[k];
    if(p.kit || !disp(k)) continue;
    if(!best || p.p < P[best].p) best=k; }
  return best;
}

/* 3.5 — ce scrie in bara: inainte de alegerea modelului, setul; dupa ea,
   exact produsele din rezultat. */
/* 3.6 — acelasi text si in rezultat: ce mai lipseste pana la prag, socotit
   din cosul real plus ce e pe cale sa adauge. */
function pragText(inPlus){
  const d=lipsaTransport(inPlus);
  if(d<=0) return 'Transport gratuit';
  const m=micPentruPrag();
  return 'Transport 19 lei — mai adaugi <b>'+lei(d)+'</b> și ai transport gratuit'+
         (m?' <button class="lnk" type="button" onclick="add(\''+m+'\')">adaugă '+P[m].t.toLowerCase().slice(0,26)+'</button>':'');
}

function stkPaint(){
  const b=document.getElementById('ckStk'); if(!b) return;
  const T=(typeof CUR!=='undefined'&&CUR)?taskList():[];
  const keys=T.filter(t=>t.p&&disp(t.p)).map(t=>t.p);
  let t1,t2,act;
  if(keys.length){
    const tot=keys.reduce((s,k)=>s+P[k].p,0);
    t1='Adaugă toate cele '+keys.length+' — '+lei(tot);
    act=()=>addAll(keys);
    const d=lipsaTransport(tot);
    t2 = d>0 ? ('Mai adaugi '+lei(d)+' și ai transport gratuit') : 'Transport gratuit';
  } else {
    const k = cuStoc('kitPhL');
    if(!k){ b.classList.add('off'); return; }
    t1=P[k].t.length>30?(P[k].t.slice(0,29)+'…'):P[k].t; t1+=' — '+lei(P[k].p);
    act=()=>add(k);
    const d=lipsaTransport(P[k].p);
    t2 = d>0 ? ('Mai adaugi '+lei(d)+' și ai transport gratuit') : 'Transport gratuit';
  }
  document.getElementById('ckStkT').textContent=t1;
  document.getElementById('ckStkS').textContent=t2;
  const btn=document.getElementById('ckStkB');
  btn.textContent='Adaugă'; btn.onclick=act;
}
/* apare dupa ce cautarea iese de pe ecran; dispare cand se deschide cosul.
   Fara temporizatoare si fara requestAnimationFrame — regula 4b.10. */
function stkVezi(){
  const b=document.getElementById('ckStk'), f=document.querySelector('.finder');
  if(!b||!f) return;
  const dr=document.querySelector('cart-drawer');
  const cosDeschis = dr && (dr.classList.contains('active')||dr.hasAttribute('open'));
  /* Banda de cookie-uri sta peste noi, si are tot dreptul: fara ea omul nu
     poate alege. Cat timp e pe ecran, bara nu se arata — altfel ar sta
     ascunsa sub ea si ar parea ca butonul nu merge. */
  const ck=document.querySelector('.cky-consent-container, .cookie-banner, #cookiescript_injected');
  const cookie = !!ck && ck.getBoundingClientRect().height>10 &&
                 getComputedStyle(ck).display!=='none' && getComputedStyle(ck).visibility!=='hidden';
  const trecut = f.getBoundingClientRect().bottom < 0;
  const ascuns = !trecut || cosDeschis || cookie;
  b.classList.toggle('off', ascuns);
  b.setAttribute('aria-hidden', ascuns?'true':'false');
}
window.addEventListener('scroll', stkVezi, {passive:true});
window.addEventListener('resize', stkVezi, {passive:true});

/* ========== pornire ========== */
paintHeroKit(); paintProw(); paintNevoi(); paintSeturi(); calcPaint(); paintCal();
stkPaint(); stkVezi(); cosCiteste();
ckBara();   /* acum pagina are inaltimea ei adevarata, deci si bara de derulare */
/* Ce se poate face abia dupa ce ajunge lista de modele. Cele doua contoare sunt
   deja scrise in pagina, ca sa le vada si Google; aici doar se confirma din date.
   Daca omul a apucat sa scrie, cautarea lui se reface singura. */
function gata(){
  const a=document.getElementById('nrMod'), b=document.getElementById('nrMod2');
  const g=MD.filter(r=>r[5]).length;
  if(a) a.textContent=MD.length;
  if(b) b.textContent=g;
  document.querySelectorAll('.nrGhid').forEach(e=>e.textContent=g);
  const q=$('#q');
  if(q && q.value.trim()) q.dispatchEvent(new Event('input',{bubbles:true}));
  dinAdresa();   /* 3.10 — abia acum stim modelele, deci abia acum se poate */
}
